import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto width-840"},[_c(VCard,{staticStyle:{"margin-top":"10px"}},[_c(VCardTitle,[_c('div',{staticClass:"title font-weight-light",staticStyle:{"width":"100%"}},[_vm._v(" Global Audit Logs ")])]),_c(VDataTable,{attrs:{"headers":_vm.headers,"items":_vm.items,"loading":!_vm.items || _vm.items.length === 0},scopedSlots:_vm._u([{key:"item.timestamp",fn:function({ item }){return [_vm._v(" "+_vm._s(item.timestamp.toDate().toLocaleString())+" ")]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }